import { useParams } from 'react-router-dom';
import { DashboardsList } from './DashboardsList';
import { DashboardView } from './DashboardView';

// Router container for the dashboards feature. The `*` wildcard holds the dashboard id when viewing
// one; absent, we show the list. Mirrors ChartsPage. Each child renders its own Page (the single
// view titles from the loaded dashboard's name).
export const DashboardPage = () => {
  const { '*': dashboardId } = useParams<{ '*'?: string }>();
  return dashboardId ? <DashboardView dashboardId={dashboardId} /> : <DashboardsList />;
};
